import GenericToken from './GenericToken';

export default GenericToken;
